import { Chip } from '@mui/material';
import { ProductArea } from '../../graphql/types';

const areaColorMap: Record<ProductArea, string> = {
  [ProductArea.App]: '#4169E1',
  [ProductArea.Offer]: '#FFA500',
  [ProductArea.Mca]: '#228B22',
  [ProductArea.User]: '#C71585',
  [ProductArea.Role]: '#6A5ACD',
  [ProductArea.Company]: '#00CED1',
  [ProductArea.Syndication]: '#00BFFF',
  [ProductArea.Platform]: '#8B008B',
  [ProductArea.Transaction]: '#B8860B',
  [ProductArea.Other]: '#778899'
};

interface AreaChipProps {
  area: ProductArea;
}

const AreaChip = ({ area }: AreaChipProps) => {
  const bgColor = areaColorMap[area] || areaColorMap[ProductArea.Other];

  return (
    <Chip
      label={area}
      size="small"
      sx={{
        height: 20,
        borderRadius: '4px',
        backgroundColor: bgColor,
        color: '#fff',
        fontWeight: 500,
        fontSize: '11px',
        '& .MuiChip-label': {
          px: 1
        }
      }}
    />
  );
};

export default AreaChip;
